export default "__VITE_ASSET__aK5f1WAV__"